export default __webpack_public_path__ + "static/media/delete-round.68730412.svg";